import { env } from "../../../env";
const axios = require("axios").default;

const URL = `${env.REACT_APP_API_URL}/api/order`;

export const getAll = (payload) => {
  return axios
    .get(`${URL}/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getInvoice = (payload) => {
  return axios
    .get(`${env.REACT_APP_API_URL}/api/print/render`, {
      params: payload,
      responseType: "blob",
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getId = (id) => {
  return axios
    .get(`${URL}/get`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createItem = (payload) => {
  return axios.post(`${URL}/add`, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateItem = (payload) => {
  return axios.put(`${URL}/update`, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteById = (payload) => {
  return axios.delete(`${URL}/delete`, { data: payload }).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
